// extracted by mini-css-extract-plugin
export default {"Container":"Container_Container__dPyVg","Player_Container":"Container_Player_Container__pInHy","Answer_Container":"Container_Answer_Container__tw8EL"};